import clsx from 'clsx';
import React from 'react';
import makeClasses from './styles';

const BoxSeparator = ({ size = 'normal', type = 'white-space', width = null, noPadding = false, lineSize = 'normal', noMargin = false }) => {
  const classes = makeClasses();

  if (type === 'white-space') {
    return <div className={clsx(classes.separator, size === 'small' ? classes.separatorSm : null)} />;
  }

  if (type === 'line') {
    return (
      <div
        className={clsx(
          classes.lineSeparatorWrapper,
          width === 'full' ? classes.lineSeparatorWrapperFull : null,
          noPadding === true ? classes.lineSeparatorWrapperWithNoPadding : null,
          lineSize === 'small' ? classes.lineSeparatorSm : null,
          noMargin ? classes.lineSeparatorWithNoMargin : null
        )}
      >
        <div className={classes.lineSeparator} />
      </div>
    );
  }

  return null;
};

export default BoxSeparator;
